import { LoginAppRoutes } from "sj-ui-toolkit/src/constants/routes";

export const REMEMBER_EMAIL_KEY = "rememberEmail";
export const USE_PASSWORD_KEY = "usePassword";

// Where svc-idp sends the browser back after the IdP completes SAML.
export const SAML_REDIRECT_TO = `${window.location.origin}${LoginAppRoutes.routes.samlRedirect.route}`;
